module.exports = __webpack_public_path__ + "img/xBlade-logo-02.0e8ccdc1.png";